import React from 'react';
import { IndexRoute, Route } from 'react-router';
import EngajeSharing from './engajeSharing';
export default (
  <Route path="engaje-sharing">
    <IndexRoute component={props => <EngajeSharing {...props} />} />
  </Route>
);
